import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { SmsDirection, SmsActivityStatus } from '@trnsact/trnsact-shared-types';
import { ActivityCardProps, SmsConversationData } from '../../types';
import { DealSmsActivity } from '../../api/types';
import { CardContainer } from './common/CardContainer';
import { generatePersonaFullName, getPersonaInitials } from 'utils/formatters';
import { MessageBubble } from './MessageBubble';

interface Props extends ActivityCardProps<DealSmsActivity> {
  onOpenConversation?: (data: SmsConversationData) => void;
}

export const MessageCard = ({ entity, onOpenConversation }: Props) => {
  const classes = useStyles();

  const isUnread = entity.smsDirection === SmsDirection.Incoming && entity.status !== SmsActivityStatus.Read;

  const { ownerPgCreditApplication } = entity;
  const contactName = generatePersonaFullName(ownerPgCreditApplication);
  const initials = getPersonaInitials(ownerPgCreditApplication.firstName, ownerPgCreditApplication.lastName);

  const handleClick = () => {
    onOpenConversation?.({
      voId: entity.parentId,
      conversationSequenceNumber: entity.conversationSequenceNumber,
      contactName,
      contactId: entity.ownerPgCreditApplicationId ?? null,
      contactPhone: ownerPgCreditApplication.phone ?? null,
      contactTitle: ownerPgCreditApplication.title ?? null,
      contactInitials: initials,
    });
  };

  return (
    <CardContainer>
      <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
        {isUnread && <Box className={classes.unreadIndicator} />}
        <Stack gap="0.75rem">
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Stack direction="row" gap="0.75rem" alignItems="center">
              <Avatar className={classes.avatar}>
                <Typography fontWeight={500}>{initials}</Typography>
              </Avatar>

              <Stack>
                <Stack direction="row" gap="0.5rem" alignItems="center">
                  <Typography variant="subtitle1" fontWeight="bold">
                    {contactName}
                  </Typography>

                  {ownerPgCreditApplication?.pc && (
                    <Box className={classes.primaryChip}>
                      <Typography
                        align="center"
                        component="span"
                        variant="subtitle2"
                        color="textSecondary"
                        sx={{ fontSize: '12px' }}
                      >
                        Primary
                      </Typography>
                    </Box>
                  )}
                </Stack>

                <Typography variant="caption" color="textSecondary">
                  {ownerPgCreditApplication?.phone}
                  {ownerPgCreditApplication?.title && ` • ${ownerPgCreditApplication.title}`}
                </Typography>
              </Stack>
            </Stack>

            {/*           {!!unreadCount && unreadCount > 0 && (
            <Badge
              badgeContent={`+${unreadCount}`}
              color="error"
              sx={{ '& .MuiBadge-badge': { position: 'static', transform: 'none' } }}
            />
          )} */}
          </Stack>

          <MessageBubble message={entity} />
        </Stack>
      </Box>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  unreadIndicator: {
    width: '4px',
    borderRadius: 2,
    backgroundColor: '#2196f3',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
  },
  avatar: {
    width: 40,
    height: 40,
    backgroundColor: '#90caf9',
    color: 'black',
    fontSize: '14px',
  },
  primaryChip: {
    borderRadius: '6px',
    padding: '2px 6px',
    color: grey[700],
    backgroundColor: grey[200],
  },
});
